import { setAmplitudeEventGroups } from 'amplitude/amplitude'
import { orgSelectors } from 'ducks/orgs'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { projectInfoSelector } from 'reducer/project/projectInfoReducer'

export const useSetAmplitudeIdentity = () => {
  const project_id = useSelector(projectInfoSelector.getProjectId)
  const project_country_iso2 = useSelector(projectInfoSelector.getProjectCountryIso2)
  const org_country_iso2 = useSelector(orgSelectors.getOrgIso2)
  const ux_version = 3
  // Todo: move this to saga
  useEffect(() => {
    setAmplitudeEventGroups({
      project_id,
      project_country_iso2,
      ux_version,
      country_iso2: org_country_iso2 || undefined,
    })
  }, [project_id, project_country_iso2, org_country_iso2, ux_version])
}
